import React from "react";
import { Nav } from "react-bootstrap";

const DrawerNavItem = ({
  id,
  name,
  order,
  activeSection,
  icon,
  closeDrawer,
}) => {
  return (
    <div
      key={id}
      id={`nav-item-${id}`}
      className={`ps-0 pe-3 ${
        activeSection === String(id) ? "issue-nav-item-active" : ""
      }`}
    >
      <Nav.Link href={`#${id}`} key={name || order} onClick={closeDrawer}>
        <div className="d-flex w-100 gap-2">
          <img src={icon} alt="issue icon" />
          {name || order}
        </div>
      </Nav.Link>
    </div>
  );
};

export default DrawerNavItem;
